<template lang="html">
  <div class="layout-page" :style="stylechat">
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
      <v-col
        cols="2"
        justify="center"
        align="center"
        class="pa-0"
        @click="routePage()"
      >
        <v-icon class="fz-30 cursor">mdi-close-circle</v-icon>
      </v-col>
      <v-col
        cols="8"
        justify="center"
        align="center"
        class="pa-0"
      >
        <span class="tab-title">{{$t('HeaderMenubar.profile')}}</span>
      </v-col>
      <v-col cols="2"></v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider>
    <v-layout row wrap justify-center align-start class="pt-5 pl-5 pr-5 pb-2">
      <v-avatar
        size="100"
      >
      <img v-if="data_friend.profilepicture" :src="data_friend.profilepicture" alt="" class="img-position">
      <img v-else-if="data_friend.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
      <img v-else-if="data_friend.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
      <img v-else-if="data_friend.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
      </v-avatar>
    </v-layout>
    <v-layout column class="mt-4" justify-center align-center style="text-align: center;">
      <span class="text-title text-overflow">{{data_friend.name}}</span>
      <span class="tab-title-status text-overflow" v-if="data_friend.status">{{data_friend.status}}</span>
      <span class="tab-title-status text-overflow" v-else>-</span>
    </v-layout>
    <v-layout row wrap justify-start align-start class="pt-6 pl-5 pr-5 pb-5 mt-2">
      <v-btn block class="btn-confirm text-transform" rounded @click="checkState(relation)" :loading="loading">
        <v-icon class="mr-2">{{icon_btn}}</v-icon>
        {{text_btn}}
      </v-btn>
    </v-layout>
    <v-divider class="ma-3"></v-divider>
    <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
      <b>{{$t('Settings.editProfile.profile')}}</b>
    </v-layout>
    <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2">
      <v-icon class="mr-3 icon-color">mdi-email</v-icon>
      <span class="tab-title-status text-overflow" v-if="data_friend.email">{{data_friend.email}}</span>
      <span class="tab-title-status text-overflow" v-else>-</span>
    </v-layout>
    <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-2 mt-2" v-if="relation === 'friend'">
      <v-icon class="mr-3 icon-color">mdi-cellphone</v-icon>
      <span class="tab-title-status text-overflow" v-if="data_friend.phone">{{data_friend.phone}}</span>
      <span class="tab-title-status text-overflow" v-else>-</span>
    </v-layout>
    <!-- <v-layout row wrap justify-start align-start class="pt-9 pl-5 pr-5 pb-2 mt-2">
      <v-btn block class="btn-confirm text-transform" rounded @click="checkState(relation)" :loading="loading">
        <v-icon class="mr-2">{{icon_btn}}</v-icon>
        {{text_btn}}
      </v-btn>
    </v-layout> -->

    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import ErrorDialog from '@/components/Alert/Error'
export default {
  data () {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      icon_btn: '',
      loading: false,
      ErrorDialogDetail: {},
      ErrorDialog: false,
      relation: '',
      text_btn: '',
      progress: false,
      data_user: {},
      data_friend: {},
      stylechat: {
        "--ProfileFriend-HeaderColor": "white",
        "--ProfileFriend-TabBackground": "white",
        "--ProfileFriend-Icon": "gray",
        "--ProfileFriend-IconActive": "#2662ae",
        "--ProfileFriend-Background": "white",
        "--ProfileFriend-FontSize": "18px",
        "--ProfileFriend-FontSize-Title": "24px",
        "--ProfileFriend-FontColor": "back",
        "--ProfileFriend-FontSize-Status": "16px",
        "--ProfileFriend-FontColor-Status": "grey",
        "--ProfileFriend-Background-Input": "#E2E1E3",
        "--ProfileFriend-Color-Button": "#EFF2FE",
        "--ProfileFriend-FontColor-Button": "#2662ae",
        "--ProfileFriend-FontColor-Block-Button": "#cb1002",
        "--ProfileFriend-FontColor-Dis-Button": "#e2e1e3",
        "--ProfileFriend-Btn-Confirm-Background": "#2662ae",
        "--ProfileFriend-Btn-Confirm-Color": "white",
        "--ProfileFriend-Btn-Confirm-FontSize": "18px",
      },
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    ErrorDialog
  },
	watch: {
		'$route' () {
			console.log("route profile");
			// var user_profile = JSON.parse(this.$cookie.get('user-profile'))
			var user_profile = ''
			if (JSON.parse(this.$cookie.get('user-profile') == null)) {
				user_profile = JSON.parse(localStorage.getItem('user-profile'))
			} else {
				user_profile = JSON.parse(this.$cookie.get('user-profile'))
			}
			this.data_user = user_profile['account']['profile']
			this.data_friend = {}
			this.relation = ""
			this.getUser(this.$route.params.tokenuser)
		},
	},
  created () {
    console.log('profile friend', this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
		this.data_friend = {}
    this.relation = ""
    this.getUser(this.$route.params.tokenuser)
  },
  methods: {
    closeAlertDialog (item) {
      if (item.type === 'err') {
        this.ErrorDialog = false
      }
    },
    routePage () {
      // this.$router.go(-1)
			console.log(this.$route.query.backpage);
      if (this.$route.query.backpage !== undefined) {
        this.$router.push(`${this.$route.query.backpage}`)
      } else {
        this.$router.go(-1)
      }
    },
    getUser (tokenfriend) {
      // console.log(tokenfriend)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
        tokenuser: this.data_user.tokenuser,
        tokenfriend: tokenfriend
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.data_friend = response.data['user']
          this.relation = response.data.relation
          if (this.relation === 'friend') {
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
          } else if (this.relation === 'request') {
            this.text_btn = this.$t('AnswerQuestion.acceptFriend')
            this.icon_btn = 'mdi-account-plus'
          } else if (this.relation === 'sendrequest') {
            this.text_btn = this.$t('AnswerQuestion.cancelRequest')
            this.icon_btn = 'mdi-account-minus'
          } else if (this.relation === 'block') {
            this.text_btn = this.$t('AnswerQuestion.unblock')
            this.icon_btn = 'mdi-lock-open'
          } else if (this.relation === 'unknown' || this.relation === 'unfriend') {
            this.text_btn = this.$t('AnswerQuestion.addFriend')
            this.icon_btn = 'mdi-account-plus'
          } else {
            this.text_btn = this.$t('AnswerQuestion.ok')
            this.icon_btn = 'mdi-account-circle'
          }
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
      })
    },
    checkState (relation) {
      if (relation === 'friend') {
        this.$router.push(`/chat-web/${this.data_friend.tokenroom}`)
      } else if (relation === 'sendrequest') {
        // ยกเลิกคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/removerequestfriend`, {
          tokenfriend: this.data_friend.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.relation = 'unknown'
            this.text_btn = this.$t('AnswerQuestion.addFriend')
            this.icon_btn = 'mdi-account-plus'
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'request') {
        // ตอบรับคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-friend`, {
          tokenfriend: this.data_friend.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
            this.relation = 'friend'
            this.data_friend.tokenroom = response.data.tokenroom
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'block') {
        // unblock
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.data_friend.tokenuser,
          tokenroom: this.data_friend.tokenroom
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.relation = 'friend'
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (relation === 'unknown' || relation === 'unfriend') {
        // add collap
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend-accept`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.data_friend.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon_btn = 'fa-solid fa-comment-dots'
            this.relation = 'friend'
            this.data_friend.tokenroom = response.data.tokenroom
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else {
				this.$router.go(-1)
			}
    }
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer !important;
}

.icon-color {
  color: var(--ProfileFriend-IconActive) !important;
}

.btn-confirm {
  background-color: var(--ProfileFriend-Btn-Confirm-Background) !important;
  color: var(--ProfileFriend-Btn-Confirm-Color) !important;
  font-size: var(--ProfileFriend-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--ProfileFriend-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--ProfileFriend-FontSize-Title) !important;
  color: var(--ProfileFriend-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--ProfileFriend-FontColor) !important;
  font-size: var(--ProfileFriend-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--ProfileFriend-FontColor-Status) !important;
  font-size: var(--ProfileFriend-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
